import { Loader2 } from 'lucide-react';

/** The in-flight mark inside a button (what Mantine's `loading` drew). */
export function Spinner() {
  return <Loader2 className="animate-spin" aria-hidden="true" />;
}
